<div class="filters">
    <input
        *ngIf="!hideTextSearch"
        (keyup)="setFilter()"
        [(ngModel)]="filterString"
        class="search"
        id="SearchFilter"
        placeholder="Type to Filter"
    />
    <div *ngIf="showAddFilter" class="service-name-container header-filter-container">
      <p-dropdown
        placeholder="Filter by Service..."
        optionLabel="name"
        optionValue="id"
        filterBy="name"
        [options]="filteredServices"
        [filter]="true"
        [showClear]="true"
        (onChange)="serviceChanged($event)"
        [(ngModel)]="selectedServiceId"
      >
        <ng-template pTemplate="filter" let-options="options">
          <div class="dropdown-filter-container">
            <div class="p-inputgroup" (click)="$event.stopPropagation()">
              <span class="p-inputgroup-addon"><i class="pi pi-search"></i></span>
              <input
                type="text"
                pInputText
                placeholder="Filter"
                (keyup)="serviceFilterChangedDebounced($event)"
                [(ngModel)]="serviceSearchText"
              />
            </div>
            <button pButton
                    icon="pi pi-times"
                    [ngClass]="{'configs-loading': servicesLoading}"
                    (click)="serviceFilterChangedDebounced($event)"
                    severity="secondary">
            </button>
            <div class="spinner" *ngIf="servicesLoading"></div>
          </div>
        </ng-template>
      </p-dropdown>
    </div>
    <div *ngIf="showAddFilter" class="identity-name-container header-filter-container">
      <p-dropdown
        placeholder="Filter by Identity..."
        optionLabel="name"
        optionValue="id"
        filterBy="name"
        [options]="filteredIdentities"
        [filter]="true"
        [showClear]="true"
        (onChange)="identityChanged($event)"
        [(ngModel)]="selectedIdentityId"
      >
        <ng-template pTemplate="filter" let-options="options">
          <div class="dropdown-filter-container">
            <div class="p-inputgroup" (click)="$event.stopPropagation()">
              <span class="p-inputgroup-addon"><i class="pi pi-search"></i></span>
              <input
                type="text"
                pInputText
                placeholder="Filter"
                (keyup)="identityFilterChangedDebounced($event)"
                [(ngModel)]="identitySearchText"
              />
            </div>
            <button pButton
                    icon="pi pi-times"
                    [ngClass]="{'configs-loading': servicesLoading}"
                    (click)="identityFilterChangedDebounced($event)"
                    severity="secondary">
            </button>
            <div class="spinner" *ngIf="identitiesLoading"></div>
          </div>
        </ng-template>
      </p-dropdown>
    </div>
    <div *ngIf="showAddFilter" class="calendar left-side-filter">
      <p-calendar
        *ngIf="hideTextSearch && showAddFilter"
        (onSelect)="setDateRangeFilter('custom')"
        [(ngModel)]="rangeDates"
        [readonlyInput]="false"
        [showTime]="true"
        [minDate]="minDate"
        [maxDate]="maxDate"
        hourFormat="12"
        inputId="range"
        showIcon="true"
        placeholder="Select Time Frame"
        selectionMode="range"
        showButtonBar="true"
        #calendar
      >
        <ng-template pTemplate="header">
          <div class="filter-button-container">
            <div
              class="toggleButton"
              [ngClass]="{ selected: selectedRange === 'hour' }"
              (click)="setDateRangeFilter('hour')"
            >
              Last Hour
            </div>
            <div
              class="toggleButton"
              (click)="setDateRangeFilter('day')"
              [ngClass]="{ selected: selectedRange === 'day' }"
            >
              Last Day
            </div>
            <div
              class="toggleButton"
              (click)="setDateRangeFilter('week')"
              [ngClass]="{ selected: selectedRange === 'week' }"
            >
              Last Week
            </div>
          </div>
        </ng-template>
      </p-calendar>
    </div>
    <div *ngIf="false && hideTextSearch && showAddFilter" class="add-filter-container add-filter-left" (click)="showFilters($event)" #filterButton [ngClass]="{'filters-added': filtersAdded, 'add-filter-open': showAdditionalFilters}">
      <div class="add-icon icon-Icon_Add"></div>
      <span class="add-icon-label">{{filtersAdded ? 'Edit' : 'Add'}} Filters</span>
    </div>

    <div class="filtered-columns-list" id="ColumnFilterContainer">
        <div
            (click)="removeFilter(filter)"
            *ngFor="let filter of filters"
            class="filtered-column-item ag-dnd-ghost ag-unselectable ag-theme-alpine"
            id="ColumnVisibility_{{ filter.filterName }}"
            title="Remove filter"
        >
            <span class="ag-dnd-ghost-icon">
                <span class="ag-icon ag-icon-filter"></span>
            </span>
            <div class="ag-dnd-ghost-label">{{ filter.filterName }}: {{ filter.label }}</div>
        </div>
    </div>
    <div id="paginationControls">
        <div *ngIf="!hideTextSearch && showAddFilter" class="add-filter-container" (click)="showFilters($event)" #filterButton [ngClass]="{'filters-added': filtersAdded, 'add-filter-open': showAdditionalFilters}">
          <div class="add-icon icon-Icon_Add"></div>
          <span class="add-icon-label">{{filtersAdded ? 'Edit' : 'Add'}} Filters</span>
        </div>
        <div (clickOutside)="closeTime()" *ngIf="isTimeSearchAvailable" id="TimeSearch">
          <div (click)="showTimeSelect()" id="TimeSelectButton">{{ dateFilter }}</div>
          <div *ngIf="isNotDialLogs" [ngClass]="{ open: isSelectingTime }"
               class="timeSearchList" id="TimeSearchList">
            <div (click)="pickDateFilter('1h')" [ngClass]="{ selected: dateFilter === '1h' }" class="time">1h</div>
            <div (click)="pickDateFilter('6h')" [ngClass]="{ selected: dateFilter === '6h' }" class="time">6h</div>
            <div (click)="pickDateFilter('24h')" [ngClass]="{ selected: dateFilter === '24h' }" class="time">24h</div>
            <div (click)="pickDateFilter('7d')" [ngClass]="{ selected: dateFilter === '7d' }" class="time">7d</div>
            <div *ngIf="isNotDialLogs" (click)="pickDateFilter('30d')" [ngClass]="{ selected: dateFilter === '30d' }" class="time">30d</div>
            <div *ngIf="isNotDialLogs" (click)="pickDateFilter('1m')" [ngClass]="{ selected: dateFilter === '1m' }" class="time">1m</div>
            <div *ngIf="isNotDialLogs" (click)="pickDateFilter('6m')" [ngClass]="{ selected: dateFilter === '6m' }" class="time">6m</div>
            <div *ngIf="isNotDialLogs" (click)="pickDateFilter('12m')" [ngClass]="{ selected: dateFilter === 'All' }" class="time">All</div>
          </div>
          <div *ngIf="!isNotDialLogs" [ngClass]="{ open: isSelectingTime  }"
               class="timeSearchList dialLogTimeSearchList" id="DialLogTimeSearchList">
            <div (click)="pickDateFilter('1h')" [ngClass]="{ selected: dateFilter === '1h' }" class="time">1h</div>
            <div (click)="pickDateFilter('6h')" [ngClass]="{ selected: dateFilter === '6h' }" class="time">6h</div>
            <div (click)="pickDateFilter('24h')" [ngClass]="{ selected: dateFilter === '24h' }" class="time">24h</div>
            <div (click)="pickDateFilter('7d')" [ngClass]="{ selected: dateFilter === '7d' }" class="time">7d</div>
          </div>
        </div>
        <div *ngIf="(isTimeSearchAvailable || showCalendarFilter) && !hideTextSearch" class="calendar">
          <p-calendar
            (onClose)="close()"
            [(ngModel)]="rangeDates"
            [readonlyInput]="false"
            [showTime]="true"
            hourFormat="12"
            inputId="range"
            placeholder="Select Time Frame"
            selectionMode="range"
            showButtonBar="true"
          ></p-calendar>
        </div>
        <div *ngIf="(isTimeSearchAvailable || showCalendarFilter) && !hideTextSearch" class="timeBox">
          <p-toggleButton
            (onChange)="handleTimeChange($event)"
            [(ngModel)]="isUTC"
            [class]="styleClass"
            [ngStyle]="style"
            iconPos="left"
            offIcon="pi pi-clock"
            offLabel="Local"
            onIcon="pi pi-clock"
            onLabel="UTC"
          ></p-toggleButton>
        </div>
        <div class="counters">
          {{ filterService.getStartElementNumber() }}-{{ filterService.getLastElementNumber() }} of
          {{ filterService.getTotalElements() }}
        </div>
        <div
            (click)="prev()"
            [ngClass]="{
                disabled: filterService.isFirstPage() || !filterService.isUsingPagination()
            }"
            class="navigate prev icon-prev"
        ></div>
        <div
            (click)="next()"
            [ngClass]="{
                disabled: filterService.isLastPage() || !filterService.isUsingPagination()
            }"
            class="navigate next icon-next"
        ></div>
    </div>
</div>
<div
  *ngIf="showAdditionalFilters"
  class="dropdown-container"
  [ngClass]="{'dropdown-loading': servicesLoading}"
  [ngStyle]="{ left: menuLeft + 'px', top: menuTop + 'px' }"
  (clickOutside)="closeFilters()"
  #filterMenu
>

</div>
